export default __webpack_public_path__ + "static/media/Conscript's Legguards of Dynastic Rule.562e350a.jpg";